import React from "react"


class PlanUpgrades extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            section_status : "hide"
            }
    }

    render() {
        return (
           <section>
                <div className="top-form">
                    <form id="modules_account"  >
                        <div className="form-row">
                            <div className="col col-md-3 no-padding">
                                <select className="form-control top-form-select " value="" name="modules" >
                                    <option value="" disabled>REVENUE INTELLIGENCE</option>
                                </select>
                            </div>
                            <div className="finder-top col col-md-4">
                                <div className="input-group">
                                    <input type="text" className="form-control" name="find_hotels" placeholder="Find.." />
                                    <div className="input-group-append">
                                        <span className="input-group-text "><i className="fa fa-search"></i></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                
                <div className="head-content "> 
                    <div className="col-md-8 px-2">     
                        <h1>Account</h1>
                        <h2>Modules and Upgrades</h2>
                        <div className="description">
                            <p>El primer paso es que nos cuentes que variables deseas medir en tu sistema, ayudanos a capturar los sub catalogos para el Magnum Leap. </p>
                        </div>
                    </div>
                    <div className="col-md-3 px-2">     
                        
                    </div>
                </div>
                <div className="news"> 
                    <div className="box notifications col-md-12">
                        <h3>NOVEDADES  |  REVENU INTELLIGENCE</h3>
                        <div>
                            <div className="line-gray-right col-md-5">
                                <div className="icon col-md-3"> 
                                    <span className="i-revenue icon-big"></span>
                                </div>
                                <div className="description col-md-9"> 
                                    <h2>Revenue Intelligence</h2>
                                    <p>No pierda más tiempo esperando sus reportes, la información que necesita está aquí, a solo unos clics de distancia.</p>
                                </div>
                            </div>
                            <div className="line-gray-right col-md-5">
                                <div className="description"> 
                                    <h2>Ventajas</h2>
                                    <ul>
                                        <li>Supervise el aumento de los ingresos por canal y por segmento de reservas.</li>
                                        <li>Vea los índices de cancelación</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <button className="btn-vcenter">VER DETALLES</button>
                            </div>
                        </div>
                        <div className="add-margintop">
                            <div className="col-md-9 news_price">
                                <h6>Precio</h6>
                                <ul>
                                    <li>$450</li>
                                    <li>USD <br />
                                        <span>MENSUAL</span>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-md-3">
                                <button className="btn-vcenter">AGREGAR A PLAN ACTUAL</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="divisor"></div>  


                    
                    <div className="col-md-12">
                        <h2 className="text-center">CONOCE LOS MÓDULOS QUE TENDREMOS DISPONIBLES PRÓXIMAMENTE</h2>
                    </div>

                <div className="box notifications col-md-12">
                        <h3>NOVEDADES  |  REVENU INTELLIGENCE</h3>
                        <div>
                            <div className="line-gray-right col-md-5">
                                <div className="icon col-md-3"> 
                                    <span className="i-revenue icon-big"></span>
                                </div>
                                <div className="description col-md-9"> 
                                    <h2>Revenue Intelligence</h2>
                                    <p>No pierda más tiempo esperando sus reportes, la información que necesita está aquí, a solo unos clics de distancia.</p>
                                </div>
                            </div>
                            <div className="line-gray-right col-md-5">
                                <div className="description"> 
                                    <h2>Ventajas</h2>
                                    <ul>
                                        <li>Supervise el aumento de los ingresos por canal y por segmento de reservas.</li>
                                        <li>Vea los índices de cancelación</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <button className="btn-vcenter">VER DETALLES</button>
                            </div>
                        </div>
                        <div className="add-margintop">
                            <div className="col-md-9 news_price">
                                <h6>Precio</h6>
                                <ul>
                                    <li>$450</li>
                                    <li>USD <br />
                                        <span>MENSUAL</span>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-md-3">
                                <button className="btn-vcenter">AGREGAR A PLAN ACTUAL</button>
                            </div>
                        </div>
                    </div>

                <div className="box notifications col-md-12">
                        <h3>NOVEDADES  |  REVENU INTELLIGENCE</h3>
                        <div>
                            <div className="line-gray-right col-md-5">
                                <div className="icon col-md-3"> 
                                    <span className="i-revenue icon-big"></span>
                                </div>
                                <div className="description col-md-9"> 
                                    <h2>Revenue Intelligence</h2>
                                    <p>No pierda más tiempo esperando sus reportes, la información que necesita está aquí, a solo unos clics de distancia.</p>
                                </div>
                            </div>
                            <div className="line-gray-right col-md-5">
                                <div className="description"> 
                                    <h2>Ventajas</h2>
                                    <ul>
                                        <li>Supervise el aumento de los ingresos por canal y por segmento de reservas.</li>
                                        <li>Vea los índices de cancelación</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <button className="btn-vcenter">VER DETALLES</button>
                            </div>
                        </div>
                        <div className="add-margintop">
                            <div className="col-md-9 news_price">
                                <h6>Precio</h6>
                                <ul>
                                    <li>$450</li>
                                    <li>USD <br />
                                        <span>MENSUAL</span>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-md-3">
                                <button className="btn-vcenter">AGREGAR A PLAN ACTUAL</button>
                            </div>
                        </div>
                    </div>





                <div className="divisor"></div> 

                <div className="contact-us"> 
                    
                    <div className="col-md-12 text-center">
                        <p className="text-center">¿No encuentra un módulo que se aplique a su caso?
                            <span>Podemos crear uno que satisfaga sus necesidades a la perfección.</span>
                        </p>
                        <button>CONTÁCTANOS</button>
                        
                    </div>
                    
                    
                </div>
            </section>
        )
    }

}

export default PlanUpgrades


// WEBPACK FOOTER //
// ./src/Setup/modules/account/views/ModulesUpgrades.js